import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoutes from './ProtectedRoutes';
import AdminOnlyRoute from './AdminOnlyRoute';

const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/default.jsx')));
const IncomePage = Loadable(lazy(() => import('../pages/entradas/IncomePage.jsx')));
const FixedCostsPage = Loadable(lazy(() => import('../pages/fixos/FixedCostsPage.jsx')));
const CardInstallmentsPage = Loadable(lazy(() => import('../pages/cartoes/CardInstallmentsPage.jsx')));
const CreditCardsPage = Loadable(lazy(() => import('../pages/carteiras/CreditCardsPage.jsx')));
const ProjectionPage = Loadable(lazy(() => import('../pages/projecao/ProjectionPage.jsx')));
const HistoryPage = Loadable(lazy(() => import('../pages/historico/HistoryPage.jsx')));
const ParametrizacoesPage = Loadable(lazy(() => import('../pages/parametrizacoes/ParametrizacoesPage.jsx')));
const AdminUsersPage = Loadable(lazy(() => import('../pages/admin/AdminUsersPage.jsx')));
const AdminRoadmapPage = Loadable(lazy(() => import('../pages/admin/AdminRoadmapPage.jsx')));
const AdminSuggestionsPage = Loadable(lazy(() => import('../pages/admin/AdminSuggestionsPage.jsx')));
const RoadmapPage = Loadable(lazy(() => import('../pages/roadmap/RoadmapPage.jsx')));
const ExpensesPage = Loadable(lazy(() => import('../pages/saidas/ExpensesPage.jsx')));
const TransacoesPage = Loadable(lazy(() => import('../pages/transacoes/TransacoesPage.jsx')));
const InsightsPage = Loadable(lazy(() => import('../pages/insights/InsightsPage.jsx')));
const MesesPage = Loadable(lazy(() => import('../pages/meses/MesesPage.jsx')));
const ProfilePage = Loadable(lazy(() => import('../pages/perfil/ProfilePage.jsx')));

const MainRoutes = {
  path: '/',
  element: <ProtectedRoutes />,
  children: [
    {
      element: <DashboardLayout />,
      children: [
        { index: true, element: <Navigate to="/dashboard" replace /> },
        { path: 'dashboard', element: <DashboardDefault /> },
        { path: 'entradas', element: <IncomePage /> },
        { path: 'fixos', element: <FixedCostsPage /> },
        { path: 'cartoes', element: <CardInstallmentsPage /> },
        { path: 'carteiras/cartoes', element: <CreditCardsPage /> },
        { path: 'projecao', element: <ProjectionPage /> },
        { path: 'saidas', element: <ExpensesPage /> },
        { path: 'historico', element: <HistoryPage /> },
        {
          element: <AdminOnlyRoute />,
          children: [
            { path: 'parametrizacoes', element: <ParametrizacoesPage /> },
            { path: 'admin/usuarios', element: <AdminUsersPage /> },
            { path: 'admin/roadmap', element: <AdminRoadmapPage /> },
            { path: 'admin/sugestoes', element: <AdminSuggestionsPage /> }
          ]
        },
        { path: 'transacoes', element: <TransacoesPage /> },
        { path: 'insights', element: <InsightsPage /> },
        { path: 'meses', element: <MesesPage /> },
        { path: 'roadmap', element: <RoadmapPage /> },
        { path: 'profile', element: <ProfilePage /> }
      ]
    }
  ]
};

export default MainRoutes;
